import { ENTRIES_ROUTES } from '../../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import entriesTypes from '../../constants/entriesTypes'
import { axios } from '../../services'

const feed_entries_um_set_icon = () => {
  return {
    type: entriesTypes.um.set_icon
  }
}

const duplicate_row_request = () => {
  return {
    type: entriesTypes.duplicate_row.request
  }
}

const duplicate_row_success = (response, rowIdx) => {
  return {
    type: entriesTypes.duplicate_row.success,
    payload: {data: response.data, rowId: rowIdx}
  }
}

const duplicate_row_failure = (messages) => {
  return {
    type: entriesTypes.duplicate_row.failure,
    payload: messages
  }
}

const duplicate_row = (feed_id, row_id, rowIdx) => {
  return function (dispatch) {
    // REQUEST
    dispatch(duplicate_row_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.duplicate_row, {feed_id: feed_id, entry_id: row_id})

    ).then( response => {
      // success
      dispatch( duplicate_row_success(response, rowIdx) )
      dispatch( feed_entries_um_set_icon() )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Couldn't duplicate row."]
      }
      dispatch( duplicate_row_failure(errors) )
    })
  }
}

const mark_read_request = () => {
  return {
    type: entriesTypes.mark_read.request
  }
}

const mark_read_success = (response, rowIdx) => {
  return {
    type: entriesTypes.mark_read.success,
    payload: {data: response.data, rowId: rowIdx}
  }
}

const mark_read_failure = (messages) => {
  return {
    type: entriesTypes.mark_read.failure,
    payload: messages
  }
}

const mark_read = (feed_id, row_id, rowIdx) => {
  return function (dispatch) {
    // REQUEST
    dispatch(mark_read_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.mark_read, {feed_id: feed_id, entry_id: row_id})

    ).then( response => {
      // success
      dispatch( mark_read_success(response, rowIdx) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Couldn't remove new entry flag."]
      }
      dispatch( mark_read_failure(errors) )
    })
  }
}


const publish_row_request = () => {
  return {
    type: entriesTypes.publish_row.request
  }
}

const publish_row_success = (response, rowIdx) => {
  return {
    type: entriesTypes.publish_row.success,
    payload: {data: response.data, rowId: rowIdx}
  }
}

const publish_row_failure = (messages) => {
  return {
    type: entriesTypes.publish_row.failure,
    payload: messages
  }
}

const publish_row = (feed_id, row_id, rowIdx) => {
  return function (dispatch) {
    // REQUEST
    dispatch(publish_row_request())

    axios.post(
      formatRoute(ENTRIES_ROUTES.publish_row, {feed_id: feed_id, entry_id: row_id})

    ).then( response => {
      // success
      dispatch( publish_row_success(response, rowIdx) )
      dispatch( feed_entries_um_set_icon() )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Couldn't publish row."]
      }
      dispatch( publish_row_failure(errors) )
    })
  }
}

const unpublish_row_request = () => {
  return {
    type: entriesTypes.unpublish_row.request
  }
}

const unpublish_row_success = (response, rowIdx) => {
  return {
    type: entriesTypes.unpublish_row.success,
    payload: {data: response.data, rowId: rowIdx}
  }
}

const unpublish_row_failure = (messages) => {
  return {
    type: entriesTypes.unpublish_row.failure,
    payload: messages
  }
}

const unpublish_row = (feed_id, row_id, rowIdx) => {
  return function (dispatch) {
    // REQUEST
    dispatch( unpublish_row_request() )

    axios.post(
      formatRoute(ENTRIES_ROUTES.unpublish_row, {feed_id: feed_id, entry_id: row_id})

    ).then( response => {
      // success
      dispatch( unpublish_row_success(response, rowIdx) )
      dispatch( feed_entries_um_set_icon() )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Couldn't unpublish row."]
      }
      dispatch( unpublish_row_failure(errors) )
    })
  }
}

export {
  duplicate_row,
  mark_read,
  publish_row,
  unpublish_row
}



// WEBPACK FOOTER //
// ./src/js/actions/entries/rows_actions.js